import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { filterByKeywordAndProps, getYFromEstimatedHeightAndRect, sleepForMS, filterByExactKeywordAndProps } from 'src/app/helpers/helpers';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Performer } from 'src/app/store/performers.era';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { Sponsor } from 'globals/store/sponsors.data';
import { SearchBarComponent } from '../search-bar';
import { Exhibitor, ExhibitorStand } from 'globals/store/exhibitors.data';
import { Entity, EntityName, ExpandedEntity } from 'globals/store/entity.data';
import { Wrapper } from '../wrapper.component';
import { ImageType } from 'globals/store/files.model';
import { Asset } from 'globals/store/assets.data';
import { Cue, Ranking } from 'globals/store/events.data';
import { DropdownOption } from 'globals/store/programs.data';
import { AddManageWrapperComponent } from '../wrappers/add-manage-wrapper.component';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { ToggleButtonWrapperComponent } from '../buttons/toggle-button-wrapper.component';
import { DropdownComponent } from '../misc/dropdown.component';
import { MutatingInputComponent } from '../joi-input/mutating-input.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { createId, jsonCopyObject } from 'globals/helpers/helpers';
import { CdkVirtualForOf, ScrollingModule } from '@angular/cdk/scrolling';
import { AssetCardComponent } from "../cards/asset-card.component";
import { WorkerCardComponent } from "../cards/workforce-card.component";
import { PerformerCardComponent } from "../cards/performer-card.component";
import { assetCategoriesDropdownReselector } from 'src/app/store/reselectors/assets.reselector';
import { templateListReselector } from 'src/app/store/reselectors/entity.reselector';
import { EntitiesService } from 'src/app/services/entities.service';

@Component({
    selector: 'entity-selector',
    template: `

<dialog-wrapper 
  *ngIf="{ new: (newEntityDialog || noEntities) && !data.tagOnly && !usingClipboard, 
    addClipText: '+ ADD FROM CLIPBOARD' + (matchingTemplates ? ' (' + matchingTemplates + ' matching)' : ''),
    normal: !noEntities && !newEntityDialog && !usingClipboard && !editingEntity,
    editing: !!editingEntity } as vars"
  [ngClass]="{ scroller: !vars.new }"
  [disabled]="!(!!editingEntity && entityChanged) && (adding || creatingFromTemplate || (usingClipboard ? !selectedTemplateCount : vars.new ? !newEntity['name'] : vars.editing || !selectedCount))"
  [cancelDisabled]=" !usingClipboard && !!data.isAddNew && !newEntity['name']"
  [backgroundColor]="data.tagOnly || data.isAddNew ? null : '#41474f'"
  [smallTitle]="true"
  [successLabel]="(usingClipboard ? 'ADD TO EVENT' : vars.editing ? 'UPDATE NAME' : data.isAddNew || !vars.new  ? 'ADD TO ' + holderName : 'CREATE ' + (entityName | uppercase))"
  [dialogTitle]="data.tagTitle ? data.tagTitle : (usingClipboard ? 'Clipboard' : data.isAddNew ? 'Add a' + (entityName === 'Exhibitor' ? 'n ' : ' ') + (entityName | lowercase) : data.tagOnly ? 'Tag ' + entityName + 's' : vars.new ? 'New ' + entityName : entityName + 's')"
  [hideBottom]="!!data.tagOnly"
  [titleHeight]="40"
  [absoluteMaxHeight]="absoluteMaxHeight"
  [giveMeTwenty]="true"
  [dontGiveExtraSpacing]="true"
  [showClose]="true"
  [showBack]="usingClipboard || (!noEntities && newEntityDialog && !data.isAddNew)"
  [cancelLabel]="data.isAddNew && !usingClipboard ? 'ADD MORE DETAIL' : 'CANCEL'"
  [cancelLeft]="newEntityDialog || vars.editing"
  (back)="goBack()"
  (cancel)="cancel()"
  (close)="data.tagOnly ? saveEntities() : data.isAddNew ? dialogRef.close() : cancel()"
  (submit)="(usingClipboard ? addTemplates() : vars.new ? addNewEntity() : vars.editing ? updateEntity() : saveEntities())"
>
  <ng-container *ngIf="!!vars.new">
    <add-manage-wrapper [hideHRule]="true" [openLabel]="!unfilteredTemplates?.length ? '' : vars.addClipText" (open)="showClipboard()">
      <div class="name-prompt">{{ data.newMessage || "Let's start with a name:" }}</div>
      <mutating-input [object]="newEntity" prop="name" [focus]="true" [placeholder]="data.newPlaceholder || entityName + ' name'" (textChange)="checkForMatchingTemplates($event)" ></mutating-input>
    </add-manage-wrapper>
  </ng-container>
  <ng-container *ngIf="!!vars.editing">
    <div class="name-prompt">Change name:</div>
    <mutating-input [object]="editingEntity" prop="name" [focus]="true" [placeholder]="data.newPlaceholder || entityName + ' name'" (textChange)="checkEntityChanged()"></mutating-input>
  </ng-container>
  <ng-container *ngIf="!!vars.normal" [ngTemplateOutlet]="listTemplate" [ngTemplateOutletContext]="{entities: unfilteredEntities, isClipboard: false, list: entityList, nDisabled: disabledCount, nSelected: selectedCount, selected: selectedEntities, addClipText: vars.addClipText }"></ng-container>
  <ng-container *ngIf="!!usingClipboard" [ngTemplateOutlet]="listTemplate" [ngTemplateOutletContext]="{entities: unfilteredTemplates, isClipboard: true, list: templatesList, nDisabled: 0, nSelected: selectedTemplateCount, selected: selectedTemplates, addClipText: vars.addClipText }"></ng-container>
</dialog-wrapper>

<ng-template #listTemplate let-entities="entities" let-list="list" let-isClipboard="isClipboard" let-nDisabled="nDisabled" 
  let-nSelected="nSelected" let-selected="selected" let-addClipText="addClipText" >
  <div class="nothing-to-select" *ngIf="!entities.length && !!data.tagOnly">
    {{ data.noEntitiesMessage || ('No ' + entityName + 's exist') }}
  </div>
  <dropdown 
    *ngIf="!!isAssets && !isClipboard" 
    [showSearch]="true"
    [selections]="assetCategoryOptions" 
    [selected]="!selectedAssetCategoryId ? {title:'',id:''} : (assetCategoryOptions | findById:selectedAssetCategoryId)"
    [null_text]="'No Asset Category'"
    (select)="selectedAssetCategoryId = $event.id; filter()"
  ></dropdown>
  <search-bar #searchBar *ngIf="!!entities.length" [debounceTime]="300" [gray]="true" [placeholder]="isClipboard ? 'Search clipboard' : data.searchPlaceholder+''" (keyword)="onSearchInput($event)"></search-bar>
  <div *ngIf="entityCreated && !isClipboard" class="performer-created">Success! {{ entityName }} created:</div>
  <div *ngIf="!data.limitSelectionToOne && list?.length && list?.length !== nDisabled" class="toggle-all" (click)="isClipboard ? toggleAllTemplates() : toggleAll()">{{ list.length - nDisabled ===  nSelected ? 'Des' : 'S'}}elect All</div>
  <cdk-virtual-scroll-viewport class="virtual-scroll" [itemSize]="list.length" [ngStyle]="{ height:list.length > 6 ? '305px' : (5 + 50 * list.length) + 'px' }"><!-- TODO [itemSize]="50"-->
    <ng-container *cdkVirtualFor="let entity of list; index as i; trackBy: trackByIndex">
      <toggle-button 
        *ngIf="{ message: !data.disabledEntityMessages ? null : data.disabledEntityMessages[entity.id] } as vars" 
        [ngClass]="{ disabled: !!vars.message, canEdit: entityName === 'Cue' }" 
        [selected]="selected[entity.id]" 
        [canHover]="canHover"
        [enabled]="!vars.message" 
        (select)="!!vars.message ? null : isClipboard ? toggleTemplate(entity.id) : toggleEntity(entity.id)"
      >
        <asset-card *ngIf="entityName === 'Asset'" [asset]="entity" [disabledMessage]="vars.message"></asset-card>
        <worker-card *ngIf="entityName === 'Workforce'" [disableSelect]="true" [disableOpenWorker]="true" [worker]="entity" [size]="36"></worker-card>
        <performer-card *ngIf="entityName === 'Performer'" [performer]="entity"></performer-card>
        <div class="generic-card" *ngIf="entityName === 'Cue'">
          <div  class="generic-name ellipsis">
            {{ entity.name || data.emptyNamePlaceholder || '' }}
          </div>
          <icon class="edit" [icon]="'EDIT'" (click)="$event.stopPropagation(); editEntity(entity)" (mouseenter)="canHover=false" (mouseleave)="canHover=true"></icon>
        </div>
        <div *ngIf="entityName !== 'Performer' && entityName !== 'Workforce' && entityName !== 'Asset' && entityName !== 'Cue'" [ngClass]="{ disabled: !!vars.message }" class="generic-card">
          <div class="generic-name ellipsis" [ngClass]="{ disabled: !entity.name && data.emptyNamePlaceholder }" >{{ entity.name || data.emptyNamePlaceholder || '' }}</div>
          <div *ngIf="!!vars.message" class="ellipsis" [innerHTML]="helpers.strWithBreak(vars.message)"></div>
        </div>
      </toggle-button>
    </ng-container>
  </cdk-virtual-scroll-viewport>
  <add-manage-wrapper *ngIf="!isClipboard && !data.tagOnly" 
    [hideHRule]="true" 
    [openLabel]="'+ NEW ' + (entityName | uppercase)"
    [secondOpenLabel]="!unfilteredTemplates?.length ? '' : addClipText"
    (open)="toggleNewEntity()"
    (secondOpen)="showClipboard()">
  </add-manage-wrapper>
</ng-template>

`,
    styleUrls: ['entity-selector.dialog.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, ScrollingModule, CdkVirtualForOf, SearchBarComponent, FindByIdPipe, AddManageWrapperComponent, CommonModule, IconComponent, ToggleButtonWrapperComponent, DropdownComponent, MutatingInputComponent, AssetCardComponent, WorkerCardComponent, PerformerCardComponent]
})
export class EntitySelectorDialogComponent extends Wrapper<EntitySelectorDialogComponent> implements OnInit {
  canHover = true
  entityList: ExpandedEntity[]
  unfilteredEntities: ExpandedEntity[]
  selectedEntities: { [eId: string]: boolean } = {}
  selectedCount = 0
  disabledCount = 0
  matchingTemplates = 0
  matchingTemplateName: string

  selectedTemplates: { [tId: string]: boolean } = {}
  selectedTemplateCount = 0
  unfilteredTemplates: Entity[]
  templatesList: Entity[]

  assetCategoryOptions: DropdownOption[]
  selectedAssetCategoryId: string


  creatingFromTemplate = false
  adding = false

  newEntity: { name?: string } = {}
  newEntityDialog = false
  
  entityCreated = false
  noEntities = false // 
  holderName = ''
  entityName: EntityName
  absoluteMaxHeight = 'calc(100vh - 40px)'
  usingClipboard = false

  entityChanged = false
  editingEntity: ExpandedEntity
  isAssets: boolean
  searchTerm = ''
  

  @ViewChild(DialogWrapperComponent) dialogWrapper : DialogWrapperComponent
  @ViewChild(SearchBarComponent) searchBar : SearchBarComponent

  constructor(public dialogRef: MatDialogRef<EntitySelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EntitySelectorData,
    private entitiesService: EntitiesService,
  ) {
    super()
    this.isAssets = data.entityName === 'Asset'
    if (this.isAssets) {
      this.selectProp(assetCategoriesDropdownReselector, null, 'assetCategoryOptions')
    }

    this.selectProp(templateListReselector, this.data.entityName, 'unfilteredTemplates')
  }

  editEntity(entity: ExpandedEntity) {
    this.canHover = true // otherwise won't hover when exiting edit bit
    this.entityChanged = false
    this.editingEntity = jsonCopyObject(entity)
    console.log("Edit cue!  ", entity)
  }

  checkEntityChanged() {
    const index = this.entityList.findIndex(e => e.id === this.editingEntity.id)
    this.entityChanged = JSON.stringify(this.entityList[index]) !== JSON.stringify(this.editingEntity)
  }

  updateEntity() {
    const index = this.entityList.findIndex(e => e.id === this.editingEntity.id)
    this.entityList[index] = this.editingEntity
    const { id, name } = this.editingEntity
    switch (this.entityName) {
      case 'Cue':
        this.eventService.updateCueName(id, name)
        break
      default:
        console.log("No update entity logic for " + this.entityName)
        break
    }

    this.editingEntity = null

  }

  toggleNewEntity() {
    this.selectedAssetCategoryId = null
    this.newEntityDialog = !this.newEntityDialog
    if (this.newEntityDialog) {
      const name = this.searchBar ? this.searchBar.getCurrentSearchValue() : '';
      this.newEntity = { name }
    }
    // console.log("Toggled back... should be refitting...")
    this.dialogWrapper.fitChildrenWithDelay(200, 40)
  }

  ngOnInit() {
    const { entities, rect, selectedEntities, entityName, entityHolderName, disabledEntityMessages, isAddNew } = this.data
    console.log({ entities, rect, selectedEntities, entityName, entityHolderName, disabledEntityMessages, isAddNew })

    if (isAddNew) this.newEntityDialog = true

    this.entityName = entityName || 'Performer'
    this.holderName = entityHolderName || 'SESSION'
    this.selectedEntities = selectedEntities ? selectedEntities : {}
    this.selectedCount = selectedEntities ? Object.values(selectedEntities).reduce((sum, selected) => sum + (selected ? 1 : 0), 0) : 0
    this.disabledCount = !disabledEntityMessages ? 0 : Object.keys(disabledEntityMessages).length

    console.log({ entities: jsonCopyObject(entities as any[]) })
    const sortedEntities = (jsonCopyObject(entities as any[]) || []).sort((entityA, entityB) => 
      !entityA.name ? 1 : !entityB.name ? -1 : 
      entityA.name.toLocaleUpperCase() < entityB.name?.toLocaleUpperCase() ? -1 : 1)
    this.unfilteredEntities = jsonCopyObject(sortedEntities)
    this.entityList = jsonCopyObject(sortedEntities)

    // height of dialog right now (with search bar + select all) is 150px + nEntities * 55px 
    const calculatedHeight = 150 + 55 * this.entityList.length
    const y = getYFromEstimatedHeightAndRect(calculatedHeight, rect)
    // console.log({ y, screenHeight: window.innerHeight })

    console.log({ y, rect })
    const left = rect.left < 20 ? 20 : rect.left > window.innerWidth - 320 ? window.innerWidth - 320 : rect.left

    if (y) {
      const maxHeight = Math.max(200, window.innerHeight - y) // because of inner minimum height and top and bottom sizes can't be shorter than 200 px.  Note this only is being set in entity-selector - may want to move similar logic to dialog-wrappers that have positioning data in them (or rework things so the ony place the position is set is in dialog-wrapper)
      this.absoluteMaxHeight = `${maxHeight}px`
      this.dialogRef.updatePosition({ top: y + 'px', left: (left - (isAddNew ? 160 : 0)) + 'px' })
    } else this.dialogRef.updatePosition({ left: left + 'px' })


    if (!this.entityList.length) {
      this.newEntityDialog = true
      this.noEntities = true
    }
  }

  trackByIndex(index) {
    return index
  }

  getSelectedCount() {
    return Object.values(this.selectedEntities).filter(s => s).length
  }
  
  toggleAll() {
    const disabled = this.data.disabledEntityMessages || {}
    const allSelected = this.entityList.length - this.disabledCount === this.getSelectedCount()
    this.entityList.forEach(e => this.selectedEntities[e.id] = !disabled[e.id] && !allSelected)
    this.selectedCount = this.getSelectedCount()
  }

  toggleEntity(entityId: string) {
    this.selectedEntities[entityId] = !this.selectedEntities[entityId]
    if (this.data.limitSelectionToOne) {
      Object.keys(this.selectedEntities).forEach( id => {
        if (id !== entityId) {
          this.selectedEntities[id] = false;
        }
      })
      this.selectedCount = this.selectedEntities[entityId] ? 1 : 0;
      return;
    }
    if (this.selectedEntities[entityId]) {
      this.selectedCount++
    } else {
      this.selectedCount--
    }
  }

  getSelectedTemplatesCount() {
    return Object.values(this.selectedTemplates).filter(s => s).length
  }
  
  toggleAllTemplates() {
    const allSelected = this.templatesList.length === this.getSelectedTemplatesCount()
    this.templatesList.forEach(e => this.selectedTemplates[e.id] = !allSelected)
    this.selectedTemplateCount = this.getSelectedTemplatesCount()
    console.log({ allSelected, count: this.selectedTemplateCount })
  }

  toggleTemplate(templateId: string) {
    this.selectedTemplates[templateId] = !this.selectedTemplates[templateId]
    if (this.selectedTemplates[templateId]) {
      this.selectedTemplateCount++
    } else {
      this.selectedTemplateCount--
    }
  }

  onSearchInput(keyword: string, exactMatch = false) {

    this.searchTerm = keyword
    this.filter(exactMatch)
  }

  filter(exactMatch = false) {
    
    let filterFunction
    const filterFunctionGenerator = exactMatch ? filterByExactKeywordAndProps : filterByKeywordAndProps
    switch (this.entityName) {
      case 'Performer':
        filterFunction = filterFunctionGenerator(this.searchTerm, ['name', 'line1', 'line2', 'email'] )
        break;
      default: // Sponsor + Exhibitor
        filterFunction = filterFunctionGenerator(this.searchTerm, ['name'] )
        break;
    }

    if (!this.usingClipboard) this.checkForMatchingTemplates(this.searchTerm)
    if (this.usingClipboard) {
      this.templatesList = (<any[]>this.unfilteredTemplates).filter(filterFunction)
    } else this.entityList = (<any[]>this.unfilteredEntities).filter(filterFunction)

    if (this.isAssets && this.selectedAssetCategoryId) this.entityList = (<Asset[]>this.entityList).filter(e => e.entityTypeId === this.selectedAssetCategoryId)
  }
  
  checkForMatchingTemplates(keyword: string) {
    this.matchingTemplates = !keyword ? 0 : (this.unfilteredTemplates || []).filter(filterByExactKeywordAndProps(keyword, ['name'])).length
    this.matchingTemplateName = keyword
  }

  resetTemplates() {
    this.entityList = [... this.unfilteredEntities]
  }

  async showClipboard() {
    this.usingClipboard = true
    this.templatesList = [... this.unfilteredTemplates]
    this.selectedTemplates = {}
    if (this.matchingTemplateName) {
      await sleepForMS(100)
      this.searchBar.setCurrentSearchValue(this.matchingTemplateName)
      this.onSearchInput(this.matchingTemplateName, !!this.matchingTemplates)
    } 
  }

  async resetEntitySelectorMinusSelections() {
    if (this.data.tagOnly) return
    this.entityList = [... this.unfilteredEntities]

  }

  goBack() {
    this.resetEntitySelectorMinusSelections()
    if (this.usingClipboard) {
      this.usingClipboard = false
    } else this.toggleNewEntity()
    
    if (!this.newEntityDialog) {
      this.matchingTemplates = 0
      this.matchingTemplateName = null
    }
    console.log({ newEntityDialog: this.newEntityDialog, templateCout: this.selectedTemplateCount })
  }

  cancel() {
    this.editingEntity = null
    if (this.data.isAddNew && !this.usingClipboard) {
      const returnData: EntitySelectorAddNewReturnData = {
        name: this.newEntity.name,
        addDetail: true
      } 
      this.dialogRef.close(returnData)
    } else this.dialogRef.close()
  }


  async addNewEntity() {

    if (this.data.isAddNew) {
      const returnData: EntitySelectorAddNewReturnData = { name: this.newEntity.name }
      this.dialogRef.close(returnData)
      return
    }
    
    let entity: Entity | ExhibitorStand | Asset
    this.adding = true
    switch (this.entityName) {
      case 'Performer':
        entity = await this.performerService.addPerformer(<Performer>this.newEntity)
        break;
      case 'Sponsor':
        entity = await this.sponsorService.addSponsor(<Sponsor>this.newEntity)
        break;
      case 'Exhibitor':
        entity = await this.exhibitorService.addExhibitor(<Exhibitor>this.newEntity)
        break;
      case 'Exhibitor Stand':
        entity = await this.exhibitorService.addExhibitorStand(<ExhibitorStand>this.newEntity)
        break;
      case 'Asset':
        const asset = <Asset>this.newEntity
        asset.icon = this.data.defaultIcon || null
        entity = await this.assetService.addAsset(asset, this.data.associatedId || null)
        break;
      case 'Cue':
        entity = <Cue>this.newEntity
        entity.id = createId()
        await this.eventService.addCue(entity as Ranking)
        break
      default:
        console.log("No entity added for " + this.entityName, this.newEntity)
        return
    }

    this.addEntity(entity)
    this.adding = false
    setTimeout(() => this.entityCreated = false, 3000)
    this.noEntities = false
    this.toggleNewEntity()
  }

  addEntity(entity: Entity | ExhibitorStand | Cue) {
    this.entityList.unshift(entity)
    this.unfilteredEntities.unshift(entity)
    if (this.data.limitSelectionToOne) {
      Object.keys(this.selectedEntities).forEach( id => {
        this.selectedEntities[id] = false;
      })
    }
    this.selectedEntities[entity.id] = true
    this.entityCreated = true
    this.selectedCount++
  }

  async addTemplates() {
    const templates = this.templatesList.filter(({id}) => this.selectedTemplates[id])  
    this.creatingFromTemplate = true

    let imageType: ImageType
    switch(this.entityName) {
      case 'Performer':
        imageType = 'performer'
        break
      case 'Sponsor':
        imageType = 'sponsor'
        break
      case 'Exhibitor':
        imageType = 'exhibitor'
        break
      case 'Asset':
        imageType = 'asset'
        break
      case 'Resource':
        imageType = 'resource'
        break
      case 'Attendee':
        imageType = 'attendee'
        break
      default:
        console.log("NO TEMPLATE HANDLING FOR " + this.entityName)
        return
    }
    
    const newEntities: Entity[] = await this.entitiesService.createEntitiesFromTemplates(imageType, templates)
    if (this.data.isAddNew) return this.dialogRef.close()

    newEntities.forEach(entity => this.addEntity(entity))
    this.newEntityDialog = false
    this.usingClipboard = false
    this.creatingFromTemplate = false
    this.noEntities = false
  }

  saveEntities() { 
    // console.log({ selectedEntities: this.selectedEntities })
    this.dialogRef.close(Object.keys(this.selectedEntities).filter(id => this.selectedEntities[id]))
  }



}

export interface EntitySelectorAddNewReturnData {
  addDetail?: boolean
  name: string
}

export interface EntitySelectorData {
  tagOnly?: boolean
  tagTitle?: string
  entities?: Entity[] | ExhibitorStand[] | Asset[]
  entityName: EntityName
  noEntitiesMessage?: string
  defaultIcon?: string // for some add exhibitor stand dialogs
  entityHolderName?: string
  searchPlaceholder?: string
  isAddNew?: boolean
  associatedId?: string
  limitSelectionToOne?: boolean
  newMessage?: string
  newPlaceholder?: string
  emptyNamePlaceholder?: string  
  canEditNames?: boolean
  disabledEntityMessages?: { [eId: string]: string }
  selectedEntities?: { [eId:string]: boolean } // for when the data is directly mutable.  For example, for cases like tagging where clicking outside of the dialog closes the dialog (but still mutates the choices passed in)
  rect: DOMRect
}